<template>
    <div>

        <ul id="classificationPlanTreeStructure" class="m-auto">

            <TreeItem
                    class="item"
                    v-for="(item, index) in classificationPlan"
                    :item="item"
                    @select-item="$emit('select-item', $event)"
                    :key="index"
                    :selectedClassLabel="selectedClassLabel"
                    :toExport="toExport"
                    :move="move"
                    :printMode = "printMode"
                    :to-review="toReview"
                    :showPopover="showPopover"
                    :showErrors="showErrors"
                    :selectable="selectable"
            ></TreeItem>
        </ul>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faHome} from '@fortawesome/free-solid-svg-icons'
    import { VueGoodTable } from 'vue-good-table';
    import axios from 'axios/index';
    import TreeItem from '../components/TreeItem';

    library.add(faHome);

    export default {
        name: 'TreeStructure',
        props: {
            selectedClassLabel: String,
            toExport: Boolean,
            classificationPlan: Array,
            move: {type: Boolean, default: false},
            printMode: Boolean,
            toReview: Boolean,
            showPopover: Boolean,
            showErrors: Boolean,
            selectable: Boolean,
        },
        components: {
            TreeItem,

        },
        mounted() {
          console.log("mounted TreeStructure");
        },
        data() {
            return {
            }

        },

        computed: {



        },
        methods: {

        }
    };
</script>



// WEBPACK FOOTER //
// src/components/TreeStructure.vue